export var FILTER_EDITOR_CLASS_PREFIX = 'FilterEditor';
export var FILTER_EDITOR_LAYOUT_HORIZONTAL = 'horizontal';
export var FILTER_EDITOR_LAYOUT_VERTICAL = 'vertical';